export default {
  settings: state => state.settings,
  incidentStatus: state => state.incidentStatus
}
